<template>
  <Fragment>
    <td>
      <px-autocomplete-cadastro-adicional
        dense
        type="ARMAZEM"
        label="Armazém"
        required
        class="required rounded-tag-small"
        v-model="formData.armazem"/>
    </td>
    <td>
      <px-autocomplete-cadastro-adicional
        dense
        type="CONTA_CONTABIL"
        label="Conta contábil"
        required
        class="required rounded-tag-small"
        v-model="formData.contaContabil"/>
    </td>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-frag';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  components: {
    Fragment,
  },
};
</script>
